import React from 'react';
import MaskedIcon from '../../coloredIcons/MaskedIcon/MaskedIcon';

// Больше чипов на плитке не помещается — остальные голоса счетчиком «+N»
const MAX_VISIBLE_CHIPS = 3;

// Знак бана перед ником: красная плашка с одним ником не читалась как голос
// за бан. Исходная картинка — черный силуэт, в чипе он белый (маской)
const BAN_ICON_PATH = '/img/icons/block.png';
const BAN_ICON_COLOR = '#ffffff';

/**
 * Кто проголосовал за бан фракции — чипы «знак бана + ник» на ее плитке.
 * Голоса открыты всем участникам лобби; свой голос («Вы») выделен.
 *
 * На мелкой плитке (6 игроков, узкий экран) ники не помещаются — там вместо
 * чипов один счетчик «⊘ N» (переключает CSS по ширине плитки, см.
 * LobbyFactionTiles.css); ники — в подсказке по наведению.
 *
 * @param {Object} props
 * @param {Array<{id: string, name: string, isOwn: boolean}>} props.voters
 */
const LobbyBanVoteChips = ({voters}) => {
  if (!voters || voters.length === 0) {
    return null;
  }
  const visibleVoters = voters.slice(0, MAX_VISIBLE_CHIPS);
  const hiddenCount = voters.length - visibleVoters.length;
  return (
    <div
      className="lobby-ban-vote-chips"
      title={`Голоса за бан: ${voters.map((voter) => voter.name).join(', ')}`}
    >
      {visibleVoters.map((voter) => (
        <span
          key={voter.id}
          className={`lobby-ban-vote-chip ${voter.isOwn ? 'lobby-ban-vote-chip_own' : ''}`}
        >
          <MaskedIcon src={BAN_ICON_PATH} color={BAN_ICON_COLOR} className="lobby-ban-vote-chip_icon"/>
          <span className="lobby-ban-vote-chip_name">{voter.name}</span>
        </span>
      ))}
      {hiddenCount > 0 && (
        <span className="lobby-ban-vote-chip lobby-ban-vote-chip_more">+{hiddenCount}</span>
      )}
      <span className={`lobby-ban-vote-count ${voters.some((voter) => voter.isOwn) ? 'lobby-ban-vote-count_own' : ''}`}>
        <MaskedIcon src={BAN_ICON_PATH} color={BAN_ICON_COLOR} className="lobby-ban-vote-chip_icon"/>
        {voters.length}
      </span>
    </div>
  );
};

export default LobbyBanVoteChips;
